import { connect } from 'react-redux';
import ApplicationForm from './ApplicationForm';
import {
  isFetching,
  getError,
  getData,
} from '../../../state/reducers/ApplicationReducer';
import ApplicationActions from '../../../state/actions/ApplicationActions';
import ConfigActions from '../../../state/actions/ConfigActions';
import { isLoaded } from '../../../state/reducers/ConfigReducer';
import { isLAO } from '../../../state/reducers/LoginReducer';

const mapStateToProps = state => ({
  isLAO: isLAO(state),
  fetching: isFetching(state),
  isLoaded: isLoaded(state),
  error: getError(state),
  application: getData(state),
});

const {
  saveRequest,
  submitRequest,
  downloadApplicationRequest,
} = ApplicationActions;
const { getConfigRequest } = ConfigActions;

export default connect(mapStateToProps, {
  save: saveRequest,
  submit: submitRequest,
  loadData: getConfigRequest,
  downloadApplicationRequest,
})(ApplicationForm);



// WEBPACK FOOTER //
// ./src/view/forms/Application/index.js